import { useCallback } from "react"

import { useAppSelector } from "../core/app/hooks"
import { RootState } from "../core/app/store"
import {
  canAll,
  canAny,
  canNotHaveAll,
  canNotHaveAny,
} from "../core/utils/access/access"

const usePermissions = () => {
  const { user } = useAppSelector((state: RootState) => state.userService)
  const permissions = user?.app_permissions ?? []

  const hasAll = useCallback(
    (permission: string | string[]) => {
      return canAll(permissions)(permission)
    },
    [permissions],
  )

  const hasAny = useCallback(
    (permission: string | string[]) => {
      return canAny(permissions)(permission)
    },
    [permissions],
  )

  const doesNotHaveAll = useCallback(
    (permission: string | string[]) => {
      return canNotHaveAll(permissions)(permission)
    },
    [permissions],
  )

  const doesNotHaveAny = useCallback(
    (permission: string | string[]) => {
      return canNotHaveAny(permissions)(permission)
    },
    [permissions],
  )
  return { hasAny, hasAll, doesNotHaveAny, doesNotHaveAll }
}

export default usePermissions
